import { useMutation, useQuery, useQueryClient } from "react-query";
import { generatePath } from "react-router-dom";
import { useApiRequest } from "system/api/hooks";
import {
  API_UPDATE_ATM_FEES,
  API_CREATE_ATM_FEES,
  API_GET_ATM_FEES,
  API_GET_ATM_FEE,
  API_DELETE_ATM_FEES,
} from "system/api/apiUrls";
import { generateUrlQuery } from "system/helpers/helperFunctions";
import { useApiErrors } from "system/helpers/apiErrorHelper";
import { useSuccessToast } from "system/helpers/hooks";
import { ErrorType } from "system/helpers/types";
import { AtmFeesDataType, AtmFeeDataType } from "modules/atmFees/types";

const getAtmFeesKey = "getAtmFeesKey";
const getAtmFeeKey = "getAtmFeeKey";
export const useGetAtmFees = (filters: any = {}) => {
  const [apiRequest] = useApiRequest();
  return useQuery(
    [getAtmFeesKey, filters],
    (): Promise<AtmFeesDataType> =>
      apiRequest({
        url: generateUrlQuery(API_GET_ATM_FEES, filters),
        method: "get",
      })
  );
};
export const useGetAtmFee = (id: string) => {
  const [apiRequest] = useApiRequest();
  return useQuery(
    [getAtmFeeKey, id],
    (): Promise<AtmFeeDataType> =>
      apiRequest({
        url: generatePath(API_GET_ATM_FEE, { id }),
        method: "get",
      })
  );
};

export const useCreateAtmFees = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_CREATE_ATM_FEES, {
          id: data.id,
        }),
        method: "post",
        data: data.data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getAtmFeesKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
export const useDeleteAtmFees = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_DELETE_ATM_FEES, {
          id: data.id,
        }),
        method: "delete",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getAtmFeesKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
export const useUpdateAtmFees = () => {
  const [apiRequest] = useApiRequest();
  const queryClient = useQueryClient();
  const { apiErrors } = useApiErrors();
  const { apiSuccessMessage } = useSuccessToast();
  return useMutation(
    (data: any) =>
      apiRequest({
        url: generatePath(API_UPDATE_ATM_FEES, {
          id: data.id,
        }),
        method: "post",
        data: data.data,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getAtmFeesKey);
        apiSuccessMessage();
      },
      onError: (err: ErrorType) => apiErrors(err),
    }
  );
};
